import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/dandang',
        name: 'dandang',
        component: LayoutNoFooter,
        children: [
            {
                path: 'tasks',
                name: 'dandang-tasks',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/tasks'),
                props: route => ({
                }),
                meta: {
                    title: '督导任务',
                    isAuth: false,
                }
            },
            {
                path: 'tasks/detail',
                name: 'dandang-tasks-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/tasksDetail'),
                props: route => ({
                }),
                meta: {
                    title: '文章详情',
                    isAuth: false,
                }
            },
            {
                path: 'progress',
                name: 'dandang-progress',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/progress'),
                props: route => ({
                }),
                meta: {
                    title: '工作进度',
                    isAuth: false,
                }
            },
            {
                path: 'progress/notes',
                name: 'dandang-progress-notes',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/progress/notes'),
                props: route => ({
                }),
                meta: {
                    title: '工作进度',
                    isAuth: false,
                }
            },
            {
                path: 'progress/followup',
                name: 'dandang-progress-followup',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/progress/followup'),
                props: route => ({
                }),
                meta: {
                    title: '工作进度',
                    isAuth: false,
                }
            },
            {
                path: 'progress/minutes',
                name: 'dandang-progress-minutes',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/progress/minutes'),
                props: route => ({
                }),
                meta: {
                    title: '工作进度',
                    isAuth: false,
                }
            },
            {
                path: 'progress/bestpractice',
                name: 'dandang-progress-bestpractice',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/progress/bestpractice'),
                props: route => ({
                }),
                meta: {
                    title: '工作进度',
                    isAuth: false,
                }
            },
            {
                path: 'progress/complaints',
                name: 'dandang-progress-complaints',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/progress/complaints'),
                props: route => ({
                }),
                meta: {
                    title: '工作进度',
                    isAuth: false,
                }
            },
            {
                path: 'experience',
                name: 'dandang-experience',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/experience'),
                props: route => ({
                }),
                meta: {
                    title: '典型经验',
                    isAuth: false,
                }
            },
            {
                path: 'experience/general',
                name: 'dandang-experience-general',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/experience/general'),
                props: route => ({
                }),
                meta: {
                    title: '综合督导报告',
                    isAuth: false,
                }
            },
            {
                path: 'experience/general/detail',
                name: 'dandang-experience-general-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/experience/generalDetail'),
                props: route => ({
                }),
                meta: {
                    title: '文章详情',
                    isAuth: false,
                }
            },
            {
                path: 'experience/special',
                name: 'dandang-experience-special',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/experience/special'),
                props: route => ({
                }),
                meta: {
                    title: '专项督导报告',
                    isAuth: false,
                }
            },
            {
                path: 'experience/special/detail',
                name: 'dandang-experience-special-detail',
                component: () => import(/* webpackChunkName: "leave" */ '@/views/dandang/experience/specialDetail'),
                props: route => ({
                }),
                meta: {
                    title: '文章详情',
                    isAuth: false,
                }
            },
        ]
    },
]
